var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Column-box"},[_c('a',{staticClass:"Column-box-content",attrs:{"href":_vm.link.url}},[_c('h2',{staticClass:"title Title-only"},[_vm._v(_vm._s(_vm.link.title))]),_c('p',[_vm._v(_vm._s(_vm.link.description))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac598934","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=slm&optionsId=0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkCard.vue
// module id = 494
// module chunks = 1